import { createContext, useState, useEffect } from 'react'
import { ThemeProvider } from "styled-components";
import {
    defaultTheme,
    darkTheme,
    greenThemme,
    redTheme,
    yellowTheme,
    grayTheme,
    pinkTheme,
} from "../styles/themes";

export const ThemeContext = createContext()

export function CustomThemeProvider({ children }) {
    const [theme, setTheme] = useState('blue')

    const handleTheme = () => {
        if (theme === "blue") {
            return defaultTheme;
        }
        if (theme === "dark") {
            return darkTheme;
        }
        if (theme === "green") {
            return greenThemme;
        }
        if (theme === "red") {
            return redTheme;
        }
        if (theme === "yellow") {
            return yellowTheme;
        }
        if (theme === "gray") {
            return grayTheme;
        }
        if (theme === "pink") {
            return pinkTheme;
        }
    };

    const handleThemeChange = (changeTheme) => {
        localStorage.setItem("@WEBPHONE.THEME", changeTheme);
        setTheme(changeTheme);
    };


    useEffect(() => {
        const findThemeExists = localStorage.getItem("@WEBPHONE.THEME");
        if (findThemeExists) {
            handleThemeChange(findThemeExists);
        }
    }, []);

    return (
        <ThemeContext.Provider value={{ theme, handleThemeChange }}>
            <ThemeProvider theme={handleTheme}>
                {children}
            </ThemeProvider>
        </ThemeContext.Provider>
    )
}